const angular = require('angular');
const uiRouter = require('angular-ui-router');

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');
const analyticsModule = require('../analytics/analytics.module');
const digitalPayModule = require('../digitalpay/digitalpay.module');

const DeliverySaverConstants = require('./delivery-saver.constants');

const { DeliverySaverBillingAddressComponentDefinition } = require('./billingaddress/delivery-saver-billing-address.component');
const { DeliverySaverComingSoonComponentDefinition } = require('./comingsoon/delivery-saver-coming-soon.component');
const { DeliverySaverConfirmationComponentDefinition } = require('./confirmation/delivery-saver-confirmation.component');
const { DeliverySaverEligibilityNotificationsComponentDefinition } = require('./eligibilitynotifications/delivery-saver-eligibility-notifications.component');
const { DeliverySaverLandingComponentDefinition } = require('./landing/delivery-saver-landing.component');
const { DeliverySaverPaymentSetupComponentDefinition } = require('./paymentsetup/delivery-saver-payment-setup.component');
const { DeliverySaverPaymentUpdateComponentDefinition } = require('./paymentupdate/delivery-saver-payment-update.component');
const { DeliverySaverPlanFrequenciesComponentDefinition } = require('./planfrequencies/delivery-saver-plan-frequencies.component');
const { DeliverySaverPlanSelectionComponentDefinition } = require('./planselection/delivery-saver-plan-selection.component');
const { DeliverySaverPlanTagComponentDefinition } = require('./plantag/delivery-saver-plan-tag.component');
const { DeliverySaverPlanTypesComponentDefinition } = require('./plantypes/delivery-saver-plan-types.component');
const { DeliverySaverSubscriptionDetailComponentDefinition } = require('./subscriptiondetail/delivery-saver-subscription-detail.component');
const { MyDeliverySaverComponentDefinition } = require('./mydeliverysaver/mydeliverysaver/my-delivery-saver.component');
const { MyDeliverySaverManagementComponentDefinition } = require('./mydeliverysaver/management/my-delivery-saver-management.component');
const { MyDeliverySaverPanelComponentDefinition } = require('./mydeliverysaver/panel/my-delivery-saver-panel.component');
const { MyDeliverySaverPaymentMethodComponentDefinition } = require('./mydeliverysaver/paymentmethod/my-delivery-saver-payment-method.component');
const { MyDeliverySaverPaymentsComponentDefinition } = require('./mydeliverysaver/payments/my-delivery-saver-payments.component');

const DeliverySaverBillingFrequency = require('./delivery-saver-billing-frequency.filter');
const DeliverySaverBillingFrequencyUnit = require('./delivery-saver-billing-frequency-unit.filter');
const DeliverySaverPaymentAmountHeading = require('./delivery-saver-payment-amount-heading.filter');
const DeliverySaverShortName = require('./delivery-saver-short-name.filter');
const DeliverySaverTypeName = require('./delivery-saver-type-name.filter');
const DeliverySaverFullTypeName = require('./delivery-saver-full-type-name.filter');

const { DeliverySaverService } = require('./delivery-saver.service');
const { MyDeliverySaverService } = require('./mydeliverysaver/my-delivery-saver.service');
const { DeliverySaverAnalytics } = require('./delivery-saver-analytics.service');

const deliverySaverModuleName = 'wowApp.deliverysaver';

angular.module(deliverySaverModuleName, [olyCommonModule, wowCommonModule, analyticsModule, digitalPayModule, uiRouter])
    .component('wowDeliverySaverBillingAddress', DeliverySaverBillingAddressComponentDefinition)
    .component('wowDeliverySaverComingSoon', DeliverySaverComingSoonComponentDefinition)
    .component('wowDeliverySaverConfirmation', DeliverySaverConfirmationComponentDefinition)
    .component('wowDeliverySaverEligibilityNotifications', DeliverySaverEligibilityNotificationsComponentDefinition)
    .component('wowDeliverySaverLanding', DeliverySaverLandingComponentDefinition)
    .component('wowDeliverySaverPaymentSetup', DeliverySaverPaymentSetupComponentDefinition)
    .component('wowDeliverySaverPaymentUpdate', DeliverySaverPaymentUpdateComponentDefinition)
    .component('wowDeliverySaverPlanFrequencies', DeliverySaverPlanFrequenciesComponentDefinition)
    .component('wowDeliverySaverPlanSelection', DeliverySaverPlanSelectionComponentDefinition)
    .component('wowDeliverySaverPlanTag', DeliverySaverPlanTagComponentDefinition)
    .component('wowDeliverySaverPlanTypes', DeliverySaverPlanTypesComponentDefinition)
    .component('wowDeliverySaverSubscriptionDetail', DeliverySaverSubscriptionDetailComponentDefinition)
    .component('wowMyDeliverySaver', MyDeliverySaverComponentDefinition)
    .component('wowMyDeliverySaverManagement', MyDeliverySaverManagementComponentDefinition)
    .component('wowMyDeliverySaverPanel', MyDeliverySaverPanelComponentDefinition)
    .component('wowMyDeliverySaverPaymentMethod', MyDeliverySaverPaymentMethodComponentDefinition)
    .component('wowMyDeliverySaverPayments', MyDeliverySaverPaymentsComponentDefinition)
    .constant('DeliverySaverConstants', DeliverySaverConstants)
    .filter('deliverySaverBillingFrequency', DeliverySaverBillingFrequency)
    .filter('deliverySaverBillingFrequencyUnit', DeliverySaverBillingFrequencyUnit)
    .filter('deliverySaverFullTypeName', DeliverySaverFullTypeName)
    .filter('deliverySaverPaymentAmountHeading', DeliverySaverPaymentAmountHeading)
    .filter('deliverySaverShortName', DeliverySaverShortName)
    .filter('deliverySaverTypeName', DeliverySaverTypeName)
    .service('DeliverySaverAnalytics', DeliverySaverAnalytics)
    .service('DeliverySaverService', DeliverySaverService)
    .service('MyDeliverySaverService', MyDeliverySaverService);

module.exports = deliverySaverModuleName;



// WEBPACK FOOTER //
// ./src/deliverysaver/deliverysaver.module.js